import React from 'react';
import styled from 'styled-components';

const BadgeWrapper = styled.span`
  display: inline-block;
  min-height: 22px;
  margin-top: 0px;
  margin-right: 5px;
  padding: 0 8px;
  font-size: 0.625rem;
  font-weight: 700;
  border-radius: 5px;
  line-height: 22px;
  color: #151515;

  &.neabaca_grants {
    background-color: #e1f7fd;
  }
  &.businesses_grants {
    background-color: #fde1fd;
  }
  &.normalClass {
    background-color: #e1fde4;
  }
`;

const Badge = (props) => {
  return (
    <BadgeWrapper className={props.classKind}>{props.children}</BadgeWrapper>
  )
}

export default Badge;